import { SurveyResponseDto } from '@act/shared/data-transfer-objects';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import SurveyInput from './inputs/input';
import { Button } from '@act/storybook';

const SurveyWrapper = styled.form`
  display: block;
  margin: 12px;

  overflow-y: 'auto';
`;

interface SurveyProps {
  response: SurveyResponseDto;
  isValidCallback?: (valid: boolean) => void;
  showSubmit?: boolean;
}

const Survey = ({
  response,
  isValidCallback,
  showSubmit = false,
}: SurveyProps) => {
  const defaults = {};
  let dateTime;
  response?.sections.map(section => {
    section.questions.map(question => {
      const options = [];
      if (question.answer) {
        let value;
        switch (question.input.inputType) {
          case 'number':
            value = question.answer?.number;
            break;
          case 'date':
            value = question.answer?.date;
            break;
          case 'date-time':
            dateTime = DateTime.fromSeconds(question.answer?.dateTime / 1000);
            value = question.answer?.dateTime
              ? dateTime.toFormat("yyyy-MM-dd'T'hh:mm")
              : '';
            break;
          default:
            value = question.answer?.text;
        }

        defaults[question.id] = value || '';
      } else {
        question.options.map(option => {
          if (option.isSelected) {
            options.push(option.id);
          }
        });
        if (question.allowMultiple) {
          defaults[question.id] = options;
        } else {
          defaults[question.id] = options[0];
        }
      }
    });
  });

  const {
    register,
    unregister,
    formState: { errors, isValid, touchedFields },
    handleSubmit,
    setValue,
    getValues,
    trigger,
    control,
  } = useForm({ mode: 'onChange', defaultValues: defaults });

  useEffect(() => {
    if (isValidCallback) {
      isValidCallback(isValid);
    }
  }, [isValid]);

  const onSubmit = data => {
    // TODO: Set SURVEY response to COMPLETE if valid
  };

  const onError = data => {
    // if user tries to submit, get all errors
    void trigger();
    // TODO: Set SURVEY response to COMPLETE if valid
  };

  return (
    <SurveyWrapper onSubmit={handleSubmit(onSubmit, onError)}>
      {response.sections.map(section => {
        return (
          <div key={section.title}>
            {response.sections?.length > 1 && section.title}
            {section.questions.map(question => {
              const touched = touchedFields[question.id];
              const error = errors[question.id];
              return (
                // @ts-ignore
                <SurveyInput
                  key={question.id}
                  question={question}
                  response={response}
                  register={register}
                  unregister={unregister}
                  setValue={setValue}
                  trigger={trigger}
                  touched={touched}
                  error={error}
                  control={control}
                  getValues={getValues}
                />
              );
            })}
          </div>
        );
      })}
      {showSubmit && (
        <Button type="submit" debounced>
          Submit
        </Button>
      )}
    </SurveyWrapper>
  );
};

export default Survey;
